import React, { useState } from 'react';
import moment from 'moment';

import CreateWorkModal from '@atom/components/common/createWorkModals/CreateWorkModal';
import colors from '@atom/styles/colors';

import { CalendarGap } from './weekViewUtils';

const styles = {
  textContain: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  gapEvent: {
    margin: '0.5rem',
    color: colors.neutral.gray,
  },
};

interface Props {
  event: CalendarGap;
  last: boolean;
}

const GapEvent = ({ event, last }: Props) => {
  const [workModalOpen, setWorkModalOpen] = useState(false);

  const handleCreateWork = () => {
    setWorkModalOpen(true);
  };

  const startTime = moment(event.plannedStartDate).format('hh:mm A');
  // Display end of current day time as 12:00 AM, even though rational human
  //  beings know it's technically the next day. Displaying it as 12am is
  //  easier for our kind to process visually
  const endTime = last ? '12:00 AM' : moment(event.dueDate).format('hh:mm A');

  return (
    <div style={styles.gapEvent}>
      <div style={styles.textContain}>
        {startTime} - {endTime}
      </div>
      <div
        style={{ ...styles.textContain, cursor: 'pointer' }}
        onClick={handleCreateWork}
      >
        + Create Work
      </div>
      <CreateWorkModal
        fromCalendarGap={event}
        open={workModalOpen}
        workTemplateRequired
        onClose={() => setWorkModalOpen(false)}
        redirectOnCreate
      />
    </div>
  );
};

export default GapEvent;
